import { Link } from 'wouter';

export function NotFoundPage(): JSX.Element {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6">
      <div className="text-center">
        <p className="text-sm font-semibold text-blue-900">404</p>
        <h1 className="mt-2 text-3xl font-bold tracking-tight text-slate-900">Sayfa bulunamadı</h1>
        <p className="mt-3 text-base text-slate-600">
          Aradığınız sayfa bulunamadı veya kaldırıldı.
        </p>
        <div className="mt-6">
          <Link
            href="/"
            className="rounded-lg bg-blue-900 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-800"
          >
            Ana Sayfaya Dön
          </Link>
        </div>
      </div>
    </div>
  );
}
